export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Light.c1b4dce5.woff";